import React from "react";
import ErrorLayer from "../components/ErrorLayer";

const ErrorPage = () => {
  return (
    <>
      {/* MasterLayout */}
        {/* Breadcrumb */}
        {/* <Breadcrumb title="404" /> */}

        {/* ErrorLayer */}
        <ErrorLayer />
    </>
  );
};

export default ErrorPage;
